// extracted by mini-css-extract-plugin
module.exports = {"separator":"separator-fHqUV","secondary":"secondary-sIeZp","tertiary":"tertiary-CKVaA","solid":"solid-nOwVS","dash":"dash-IpUSH"};